var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "living-option-properties"
  }, [_c('transition-group', {
    on: {
      "before-enter": _vm.beforeEnter,
      "enter": _vm.enter,
      "afterEnter": _vm.afterEnter,
      "beforeLeave": _vm.beforeLeave,
      "leave": _vm.leave,
      "afterLeave": _vm.afterLeave
    }
  }, _vm._l(_vm.activeProperties, function (child, index) {
    return _c('router-link', {
      key: child._id,
      attrs: {
        "data-index": index,
        "tag": "div",
        "to": _vm.getRouterLink(child)
      }
    }, [child.marker ? _c('AvailabilityMarker', {
      attrs: {
        "filtered": child.filtered,
        "x": child.marker.x,
        "y": child.marker.y,
        "status": child.status,
        "isDisplayHome": child.isDisplayHome,
        "productType": child.productType,
        "specialCondition": child.specialCondition,
        "hide": child.hide
      }
    }) : _vm._e(), _vm._l(child.polygons, function (polygon, i) {
      return _c('polygon-shape', {
        key: polygon._id || "".concat(child._id, "-").concat(i),
        attrs: {
          "polygon": polygon
        }
      });
    })], 2);
  }), 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }